var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrushAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 17.8471C2 15.5535 3.85934 13.6942 6.15294 13.6942C8.44655 13.6942 10.3059 15.5535 10.3059 17.8471C10.3059 20.1407 8.44655 22 6.15294 22H3.03824C2.46483 22 2 21.5352 2 20.9618V17.8471Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2892 2.54812C18.7929 2.19151 19.3949 2 20.0121 2C21.11 2 22 2.89002 22 3.9879C22 4.60509 21.8085 5.20707 21.4519 5.7108L19.4287 8.56863C18.1364 10.3942 16.7064 12.1163 15.152 13.7202C14.7274 11.2342 12.7656 9.27255 10.2796 8.84808C11.8834 7.29374 13.6055 5.86378 15.4311 4.57143L18.2892 2.54812Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6801 14.7325V15.1687C13.3875 15.4433 13.0911 15.714 12.7908 15.9806L11.7812 16.877C11.3745 14.5006 9.49922 12.6254 7.12271 12.2189L8.01949 11.2089C8.28598 10.9088 8.55652 10.6125 8.83101 10.32H9.26765C11.7046 10.32 13.6801 12.2955 13.6801 14.7325Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrushAlt);
export default __webpack_public_path__ + "static/media/brush-alt.4e44511e261537b82794acd6a200bfd5.svg";
export { ForwardRef as ReactComponent };